<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <v-card flat>
      <v-card-text class="px-0">
        <h3 class="mb-4 px-4">{{ $t('Gauti pranešimai') }}</h3>

        <ntr-pranesimai-search
          :loading="loading"
          @search="searchNtrPranesimai"
        />

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="filterItemList"
          :search="search"
          :item-class="rowClass"
          :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageText: this.$t('Rodyti po:'),
            itemsPerPageAllText: this.$t('visi'),
            itemsPerPageOptions: itemsPerPageOptions,
          }"
          :hide-default-footer="hideFooter"
          :sort-by.sync="pagination.sort"
          :sort-desc.sync="pagination.sortDesc"
          :server-items-length="pagination.total"
          :items-per-page="pagination.pageSize"
          :page.sync="pagination.page"
          @update:options="updatePagination"
        >
          <template #[`item.pranesimo_rusis`]="{ item }">
            {{ item.dokumento_rusis }}
            <div class="font-normal mt-2" v-if="item.atmetimo_priezastis">
              {{ $t('Atmetimo priežastis:') }}
              {{ item.atmetimo_priezastis }}
            </div>
          </template>
          <template #[`item.actions`]="{ item }">
            <div class="font-normal">
              <el-byla
                v-for="byla in item.bylos"
                :key="byla.byl_id"
                :byla="byla"
                @bylaOpen="setSeen(item)"
              />
            </div>
            <div class="nowrap">
              <el-table-action :item="item" @viewItem="editItem(item)" />
            </div>
          </template>
          <template slot="loading">
            {{ $t('Kraunasi...') }}
          </template>
          <template slot="no-results">
            {{ $t('Duomenų nėra') }}
          </template>
          <template slot="no-data">
            {{ $t('Duomenų nėra') }}
          </template>
          <template #[`footer.page-text`]="props">
            {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
            {{ $t('iš') }}
            {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import rowClass from '../../mixins/rowClass'
import NtrPranesimaiSearch from './NtrPranesimaiSearch'
import NtrPaslaugosMap from './NtrPaslaugosMap'
import PazymaMap from '../pazyma/PazymaMap'

export default {
  name: 'NtrPranesimai',
  mixins: [rowClass],
  components: {
    NtrPranesimaiSearch,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      pranesimai: [],
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,
      lockInterval: null,
      lockTimeout: 10000,
      searchData: {},
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    headers() {
      return [
        {
          text: this.$t('Pranešimo numeris'),
          align: 'start',
          sortable: false,
          value: 'zus_numeris',
          width: 120,
        },
        {
          text: this.$t('Pranešimo data'),
          align: 'start',
          sortable: false,
          value: 'pranesimo_data',
          width: 100,
        },
        {
          text: this.$t('Pranešimo rūšis'),
          align: 'start',
          sortable: false,
          value: 'pranesimo_rusis',
        },
        {
          text: this.$t('Prašymo numeris'),
          align: 'start',
          sortable: false,
          value: 'prasymas',
          width: 130,
        },
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 50,
        },
      ]
    },
    filterItemList() {
      return this.pranesimai.map(pranesimas => {
        const prasymasMap = NtrPaslaugosMap.getPrasymasTipas(
          pranesimas.pra_tipas
        )
        pranesimas.routeList = 'ntrGautiPranesimai'
        pranesimas.routeEdit = prasymasMap.routeEdit
        pranesimas.routeSign = prasymasMap.routeSign

        pranesimas.canView = pranesimas.can_view
        pranesimas.not_seen = !pranesimas.zus_perziuretas
        pranesimas.bylos = pranesimas.bylos.map(byla => {
          return {
            ...byla,
            byl_url: `ntrpaslaugos/byla/${byla.byl_id}/${byla.byl_hash}/content`,
            pranesimas_numeris: pranesimas.zus_numeris,
          }
        })

        pranesimas.prasymas = pranesimas.pra_id ?? pranesimas.paz_id

        return pranesimas
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    isLocked() {
      return this.pranesimai.filter(item => item.obj_uzrakinta).length > 0
    },
  },
  created() {
    this.loading = true
    this.pageloading = true
    // this.getData()
  },
  methods: {
    getData(resetPageNr = false) {
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`ntrpaslaugos/gauti-pranesimai`, data)
        .then(res => {
          this.pranesimai = res.data.pranesimai
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchNtrPranesimai(searchData) {
      this.searchData = searchData
      this.getData(true)
    },
    editItem(item) {
      this.setSeen(item)
      if (item.paz_id && item.paz_tipas) {
        this.editPazyma(item)
        return
      }
      if (item.pra_id && item.pra_tipas) {
        this.editPrasymas(item)
        return
      }

      window._VMA.$emit(
        'DATA_ERROR',
        'Šis pranešimas buvo pašalintas, dėl to jo peržiūra nėra galima.'
      )
    },
    editPrasymas(prasymas) {
      const prasymasID = prasymas.pra_id
      this.$store.dispatch('prasymasID', prasymasID).then(
        this.$store.dispatch('prasymasTipas', prasymas.pra_tipas).then(() => {
          const listInfo = {
            prasymasID: prasymasID,
            routeName: prasymas.routeList,
          }
          this.$store.dispatch('listInfo', listInfo).then(
            this.$router.push({
              name: prasymas.routeSign,
              params: {
                prasymasID: prasymasID,
                step: 'registravimas',
              },
            })
          )
        })
      )
    },
    editPazyma(pazyma) {
      const pazymaID = pazyma.paz_id
      const pazymaMap = PazymaMap.getPazymaTipas(pazyma.paz_tipas)

      this.$store.dispatch('pazymaID', pazymaID).then(
        this.$store.dispatch('pazymaTipas', pazyma.paz_tipas).then(() => {
          const listInfo = {
            pazymaID: pazymaID,
            routeName: pazyma.routeList,
          }
          this.$store.dispatch('listInfo', listInfo).then(() => {
            this.$router.push({
              name: pazymaMap.routeEdit,
              params: {
                pazymaID: pazymaID,
              },
            })
          })
        })
      )
    },
    setSeen(item) {
      this.$axios
        .post(`pranesimas/${item.zus_id}/perziuretas`)
        .then(res => {
          //
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          item.zus_perziuretas = true
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.font-normal {
  font-weight: 100 !important;
}
.pazyma-expanded {
  box-shadow: none;
  background: rgb(248, 248, 248);
  padding-top: 0px !important;
}
</style>
